import IMask from 'imask'
import { InputType } from './air-input.types'

export const InputPresets: {
  date: IMask.MaskedDateOptions
} & Partial<Record<InputType, IMask.AnyMaskedOptions>> = {
  number: {
    mask: Number,
    thousandsSeparator: ',',
    normalizeZeros: true,
    radix: '.',
  },
  currency: {
    mask: '$ currency',
    blocks: {
      currency: {
        mask: Number,
        padFractionalZeros: true,
        thousandsSeparator: ',',
        radix: '.',
      },
    },
  },
  tel: {
    mask: '+{1} 000-0000',
  },
  'zip-code': {
    mask: '00000',
  },
  'credit-card': {
    mask: '0000-0000-0000-0000',
  },
  expiry: {
    mask: '00/00',
  },
  date: {
    mask: Date,
    pattern: 'm-`d-`Y',
    blocks: {
      d: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31,
        maxLength: 2,
      } as IMask.AnyMaskedOptions,
      m: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12,
        maxLength: 2,
      } as IMask.AnyMaskedOptions,
      Y: {
        mask: IMask.MaskedRange,
        from: 1900,
        to: 9999,
      } as IMask.AnyMaskedOptions,
    },
    format: function (date: Date): string {
      let day: string | number = date.getDate()
      let month: string | number = date.getMonth() + 1
      const year: string | number = date.getFullYear()

      if (day < 10) day = `0${day}`
      if (month < 10) month = `0${month}`

      return [month, day, year].join('-')
    },
    parse: function (str: string): Date {
      const dayMonthYear: number[] = str.split('-').map((item: string) => Number(item))
      const date = new Date()
      date.setFullYear(dayMonthYear[2], dayMonthYear[0] - 1, dayMonthYear[1])
      return date
    },
    autofix: true,
    lazy: true,
    overwrite: true,
  },
  'date-year': {
    mask: '0000',
  },
}
